import {useEffect} from 'react';

export default function useLockHTMLScroll({
  lockBodyClass,
  stateOnWhichLockToggles,
}: {
  lockBodyClass?: string;
  stateOnWhichLockToggles: boolean;
}) {
  useEffect(() => {
    const htmlLockClassName = lockBodyClass || 'lock-scroll';
    const htmlEl = document.querySelector('html');
    const lockHTMLScroll = () => htmlEl?.classList.add(htmlLockClassName);
    const unLockHTMLScroll = () => htmlEl?.classList.remove(htmlLockClassName);

    if (stateOnWhichLockToggles) {
      // make html not scrollable
      lockHTMLScroll();
    } else {
      unLockHTMLScroll();
    }

    return () => {
      // bring back scroll on unmount
      unLockHTMLScroll();
    };
  }, [stateOnWhichLockToggles]);
}
